import { selectedTasksSelector } from "./selectedTasksSelector";
import { RootState } from "../../../store";

export const selectedTasksLengthSelector = (state: RootState) => {
  const tasks = selectedTasksSelector(state);

  return tasks.length;
};
